import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HttpService from "../services/HttpServices"; // Adjust the import path as necessary
import toast from "react-hot-toast";

const apiService = HttpService; // Ensure this is set in your environment

// Initial state with an additional key for storing added product details
const initialState = {
  orderData: null,
  productList: [],
  products: [], // Assuming you have a list of products
  productTypeList: [],
  productUOMList: [],
  productData: null,
  addProductData: null,
  loading: false,
  error: null,
  status: "idle",
  productPageInfo: {},
  getProductData: {},
};
// Async thunk for creating a Business Unit
export const createProduct = createAsyncThunk(
  "products/createProduct",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/admin/products", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Set this to indicate form data
        },
      });
      return response.data; // response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (queryParams, thunkAPI) => {
    try {
      //  console.log('check Product :', apiService + '/products/' + queryParams)
      const response = await apiService.get("/admin/products/");
      const products = response.data.data;
      return products;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
);

// TO update the product details
export const updateProductById = createAsyncThunk(
  "products/updateProductById",
  async ({ productId, productData }, { rejectWithValue }) => {
    try {
      const response = await apiService.put(
        `/admin/products/${productId}`,
        productData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Set this to indicate form data
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
export const getProductsByID = createAsyncThunk(
  "products/getProductsByID",
  async ({ productId }, { rejectWithValue }) => {
    try {
      // console.warn("PRODUCTID FOR ",productId)
      const response = await apiService.get(`/admin/products/${productId}`);
      //  const response = await apiService.get(url, productData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "products/deleteProduct",
  async ({ productId }, { rejectWithValue }) => {
    try {
      const response = await apiService.delete(`/admin/products/${productId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
export const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    resetProductData: (state) => {
      state.productList = [];
      state.productTypeList = [];
      state.productUOMList = [];
      state.orderData = null;
      state.productData = null;
      state.addProductData = null;
      state.loading = false;
      state.error = null;
      (state.productPageInfo = {}), (state.getProductData = {});
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.productList = action.payload;
        state.productPageInfo = {
          totalRecords: action.payload.totalRecords,
        };
      })
      .addCase(fetchProducts.rejected, (state) => {
        state.status = "failed";
      })
      // Handling create Business Unit
      .addCase(createProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // To Update Product details
      .addCase(updateProductById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProductById.fulfilled, (state, action) => {
        state.loading = false;
        state.updateProductData = action.payload.data;
        state.error = null;
      })
      .addCase(updateProductById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // To get the products by id
      .addCase(getProductsByID.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProductsByID.fulfilled, (state, action) => {
        console.log("action==in slice=>", action);
        state.loading = false;
        state.getProductData = action.payload.data;
        state.error = null;
      })
      .addCase(getProductsByID.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // To get the deleted Product by id
      .addCase(deleteProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.productData = action.payload.data;
        state.error = null;
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default productsSlice.reducer;
